import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { publicPages } from 'routes/menu';
import { setRedirect } from '../../../features/app/appSlice';

interface Props {
  redirectPath?: string;
}

const ProtectedRoutes: FC<Props> = ({ redirectPath = publicPages.login.path }) => {
  const isAuth = useSelector((state) => state.user.isAuth);
  const dispatch = useDispatch();
  const location = useLocation();

  if (!isAuth) {
    dispatch(setRedirect({ redirectPath: location.pathname + location.search }));
    return <Navigate to={redirectPath || '/login'} replace />;
  }
  return <Outlet />;
};

export default ProtectedRoutes;
